import { useState, useEffect } from 'react';

/**
 * Prevents the state from changing until the delay has passed. If state
 * changes occur during the delay, the delay time is reset.
 * Good to use if a state change triggers API calls. This plays nicely with
 * react components as opposed to the packages/debounce or lodash function.
 */
export const useDebouncedState = <StateType>(
    state: StateType,
    delay: number,
) => {
    const [debouncedState, setDebouncedState] = useState<StateType>(state);

    useEffect(() => {
        const handler = setTimeout(() => setDebouncedState(state), delay);

        return () => clearTimeout(handler);
    }, [state, delay]);

    return debouncedState;
};
